@let isMobile = isMobile$ | async;

<p-menubar [model]="isMobile ? [] : navigationItems()" [dt]="menubarHeaderDesignToken">
	<ng-template #start>
		<div class="start-content">
			<div class="brand-text" (click)="navigateToDashboard()" (keydown.enter)="navigateToDashboard()" tabindex="0" role="button" data-testid="nav-dashboard-link">ANALYZER</div>
			@if (!isMobile) {
				<div class="environment-selector">
					<p-select
						[options]="environments()"
						[(ngModel)]="selectedEnvironment"
						optionLabel="label"
						placeholder="Select Environment"
						[style]="{ 'min-width': '120px' }"
						appendTo="body"
						data-testid="nav-environment-select"
					/>
				</div>
			}
		</div>
	</ng-template>
	<ng-template #end>
		<div class="end-content">
			<a [href]="homeUrl">
				@if (isMobile) {
					<img class="traton-logo-mobile" alt="Traton logo" src="assets/traton/logos/TRATON_Super_sign_RGB_White.svg" />
				} @else {
					<img class="traton-logo" alt="Traton logo" src="assets/traton/logos/TRATON_Logo_RGB_white.png" />
				}
			</a>
			<p-button #menuButton size="small" icon="pi pi-bars" styleClass="header-menu-btn" (onClick)="menu.toggle($event)" data-testid="nav-menu-button" />
		</div>
		<!-- Right-side hamburger menu  -->
		<p-tieredmenu #menu [dt]="menuDesignToken" popup="true" [model]="(menuItems$ | async) ?? undefined" appendTo="body" />
		@if (authService.userData$ | async; as userData) {
			<!-- User details drawer -->
			<p-drawer [dt]="drawerDesignToken" header="User details" [(visible)]="showUserDetails" modal="true" position="right" closable="true" appendTo="body">
				@defer (when showUserDetails) {
					@if (userData) {
						<div class="table-container">
							<div>
								<table>
									<tr>
										<td class="table-row">Name</td>
										<td class="table-row">{{ userData?.firstName }} {{ userData?.lastName }}</td>
									</tr>
									<tr>
										<td class="table-row">Company</td>
										<td class="table-row">{{ userData?.companyName }}</td>
									</tr>
									<tr>
										<td class="table-row">Username</td>
										<td class="table-row">{{ userData?.userName }}</td>
									</tr>
								</table>
							</div>
							<div class="table-title">
								<h4><b>Environments</b></h4>
							</div>
							@if (environments()) {
								@for (env of environments(); track $index) {
									<div class="table-row">
										{{ env.label }}
									</div>
								}
							} @else {
								<div style="align-items: center; display: flex">
									<p-progressSpinner />
								</div>
							}
						</div>
					} @else {
						<div style="align-items: center; display: flex">
							<p-progressSpinner />
						</div>
					}
				}
			</p-drawer>
		}
		<!-- Treo Environments drawer: which sub-environments' runs appear in the data.
         Only shown/opened for the TREO environment. -->
		<p-drawer header="Treo Environments" [(visible)]="showTreoEnvironments" modal="true" position="right" [closable]="true" [dt]="drawerDesignToken" styleClass="treo-env-drawer" appendTo="body">
			@let selectedTreoEnvs = (selectedTreoEnvironments$ | async) ?? [];
			@let isLastOne = selectedTreoEnvs.length === 1;

			<div class="treo-env-list">
				@for (opt of treoEnvironmentOptions; track opt.value) {
					@let isChecked = selectedTreoEnvs.includes(opt.value);
					@let isLocked = isChecked && isLastOne;
					<!-- Clicking anywhere on the row (checkbox or label) toggles the environment, unless it's
               the locked last one. The wrapper carries the tooltip because a disabled checkbox
               doesn't emit hover events. -->
					<span
						class="treo-env-row"
						[class.treo-env-row-locked]="isLocked"
						[pTooltip]="isLocked ? 'At least one environment must stay selected' : ''"
						tooltipPosition="top"
						(click)="!isLocked && toggleTreoEnvironment(opt.value)"
						(keydown.enter)="!isLocked && toggleTreoEnvironment(opt.value)"
						tabindex="0"
						role="button"
						[attr.data-testid]="'nav-treo-env-row-' + opt.value"
					>
						<!-- Display only: the row click above drives the toggle. pointer-events are disabled on
                 the checkbox (see SCSS) so a click on it can't also flip Optimus UI's own internal
                 state — that double toggle is what forced two clicks. -->
						<p-checkbox class="treo-env-checkbox" [binary]="true" [ngModel]="isChecked" [disabled]="isLocked" data-testid="nav-treo-env-checkbox" />
						<span class="treo-env-label">{{ opt.label }}</span>
					</span>
				}
			</div>

			@if (isLastOne) {
				<small class="treo-env-hint">At least one environment must stay selected.</small>
			}
		</p-drawer>
		<!-- Privacy & data drawer: informational analytics notice, shared wording from the SDK -->
		<p-drawer header="Privacy & Data" [(visible)]="showPrivacyNotice" modal="true" position="right" [closable]="true" [dt]="drawerDesignToken" appendTo="body">
			@if (privacyNotice; as notice) {
				<div class="privacy-notice">
					<h4>{{ notice.full.title }}</h4>
					<p>{{ notice.full.intro }}</p>
					@for (section of notice.full.sections; track section.title) {
						<section class="privacy-notice__section">
							<h5>{{ section.title }}</h5>
							<p>{{ section.body }}</p>
						</section>
					}
				</div>
			}
		</p-drawer>
	</ng-template>
</p-menubar>
